import mixpanel from 'mixpanel-browser'

export function track(eventLabel, options = {}) {
  try {
    mixpanel.track(eventLabel, {
      system_id: window.location.host,
      ...options,
    })
  } catch (error) {
    console.log(error)
  }
}

export function trackDeleteRule(type, directorRuleName) {
  track(`Delete ${type} Rule`, {
    directorRuleName,
  })
}

export function trackOnOffRuleProperty(
  ruleType,
  property,
  oldValue,
  newVale,
  directorRuleName,
) {
  let change = undefined

  if (oldValue && !newVale) {
    change = 'Off'
  } else if (!oldValue && newVale) {
    change = 'On'
  }

  if (change) {
    track(`${ruleType} Rule - ${property} - ${change}`, {
      directorRuleName,
    })
  }
}

export default {
  track,
}
